import { COMPONENT_NAME_PREFIX, KEYSTROKE_DEBOUNCE_THRESHOLD } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "autocomplete";
var attributes = {
    MODE: 'mode',
    MULTIPLE: 'multiple',
    DEBOUNCE: 'debounce',
    HIGHLIGHT_FIRST: 'highlight-first',
    FILTER_ON_FOCUS: 'filter-on-focus',
    ALLOW_UNMATCHED: 'allow-unmatched',
    POPUP_TARGET: 'popup-target',
    POPUP_CLASSES: 'popup-classes',
    OPTION_LIMIT: 'option-limit',
    OBSERVE_SCROLL: 'observe-scroll',
    OBSERVE_SCROLL_THRESHOLD: 'observe-scroll-threshold',
    SYNC_POPUP_WIDTH: 'sync-popup-width',
    OPEN: 'open',
    SELECT_ON_BLUR: 'select-on-blur',
    MATCH_KEY: 'match-key'
};
var selectors = {
    INPUT: 'input,textarea',
    DROPDOWN_ICON: '[data-tyl-dropdown-icon],[tcw-dropdown-icon],.tyl-dropdown-icon'
};
var numbers = {
    DEFAULT_DEBOUNCE_TIME: KEYSTROKE_DEBOUNCE_THRESHOLD,
    NUM_SKELETON_ITEMS: 3
};
var events = {
    CHANGE: elementName + "-change",
    SELECT: elementName + "-select",
    SCROLLED_BOTTOM: elementName + "-scrolled-bottom"
};
export var AUTOCOMPLETE_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    selectors: selectors,
    numbers: numbers,
    events: events
};
export var AutocompleteMode;
(function (AutocompleteMode) {
    AutocompleteMode["Default"] = "default";
    AutocompleteMode["Stateless"] = "stateless";
})(AutocompleteMode || (AutocompleteMode = {}));
